import React, { useEffect, useState } from "react";
import SingleUserCard from "../components/SingleUserCard";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";

export default function AllUsers() {
  // State Handling
  const [usersData, setUsersData] = useState({
    user_img: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_password: "",
    user_home_address: "",
    user_phone_number: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [fetchedData, setFetchedData] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Users From Database ---------
  const readingData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/read-users"
      );
      const result = await response.json();

      if (!response.ok) {
        setSuccess("");
        setError("Users can't be fetched");
      } else if (response.ok) {
        setTimeout(() => {
          setError("");
        }, 10000);
        const filteringUsers = Array.from(
          new Set(
            result.filter((user) => {
              return user.is_Admin == false;
            })
          )
        );
        setFetchedData(filteringUsers);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readingData();
  }, []);

  // --------- Deleting ---------
  const deleteHandler = async (userEmail) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/delete-user/${userEmail}`,
      {
        method: "DELETE",
      }
    );

    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("User can't be deleted");
    } else if (response.ok) {
      setError("");
      setSuccess("User Deleted Successfully");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    }

    // Reading the users again
    readingData();
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Fetching...</p>
      </div>
    );

  if (!loading)
  return (
    <>
      {/* Showing Alert based on http request response Start */}
      {success && <SuccessAlert successMsg={success} />}
      {error && <ErrorAlert errorMsg={error} />}
      {/* Showing Alert based on http request response End */}

      {/* All Users Heading Start */}
      <AdminPanelGeneralHeading text="All Users" />
      {/* All Users Heading End */}

      {/* All Users Cards Start*/}
      <div className="all-users-cards col-12 d-flex gap-4 flex-wrap justify-content-start align-items-stretch">
        {!fetchedData?.length ? <NothingToShow /> : ""}

        {fetchedData?.map((singleUser) => {
          return (
            <SingleUserCard
              key={singleUser._id}
              userImg={singleUser.user_img}
              userFirstName={singleUser.user_first_name}
              userLastName={singleUser.user_last_name}
              userEmail={singleUser.user_email}
              userMobile={singleUser.user_phone_number}
              userPassword={singleUser.user_password}
              userAddress={singleUser.user_home_address}
              deleteHandler={deleteHandler}
            />
          );
        })}
      </div>
      {/* All Users Cards End */}
    </>
  );
}
